import { z } from "zod";
const AppointmentSummaryEventSchema = z.object({
    id: z.string(),
    beginTime: z.string().datetime(),
    endTime: z.string().datetime(),
});
export const CustomerAppointmentSummarySchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("upcoming"),
        event: AppointmentSummaryEventSchema,
        serverNow: z.string().datetime(),
    }),
    z.object({
        kind: z.literal("past"),
        event: AppointmentSummaryEventSchema,
        serverNow: z.string().datetime(),
    }),
    z.object({
        kind: z.literal("none"),
        event: z.null(),
        serverNow: z.string().datetime(),
    }),
]);
//# sourceMappingURL=customerAppointmentSummary.js.map